var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.374 11.807l5.34-5.34a.66.66 0 000-.933L2.374.194a.66.66 0 00-.933 0L.818.815a.66.66 0 000 .932L5.05 6 .817 10.252a.66.66 0 00.001.932l.623.623a.66.66 0 00.933 0z"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 8 12"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
